module.exports = __webpack_public_path__ + "static/media/logo-white.15b1eef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-white.png
// module id = 549
// module chunks = 0